export default "__VITE_ASSET__xDIRzWje__"